<style>
  .layout.row {
    margin-bottom: 20px!important;
  }
</style>
<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Уровни</h3>
          <v-btn
                  color="pink"
                  dark
                  small
                  fab
                  @click="editOpen()"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
                  color="blue"
                  dark
                  small
                  fab
                  @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>        
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Поиск"
              v-model="search"
              hide-details
              class="hidden-sm-and-down"
              ></v-text-field>     
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>         
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="levelData"
                :rows-per-page-items="[10,25,50,100]"
                class="elevation-1"
                item-key="name"
                no-results-text="Нет результатов"
                rows-per-page-text="На странице"
                v-model="complex.selected"
                >
                <template slot="items" slot-scope="props">

                  <td>{{ props.item.levelId }}</td>
                  <td>{{ props.item.levelKey }}</td>
                  <td>{{ props.item.levelTitle }}</td>
                  <td>

                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>

                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->

              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID уровня</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="ID уровня"
                                    v-model="modalData.levelId"
                                    readonly
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Внешний ключ для уровня</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <span v-if="readonlyFields">{{modalData.levelKey}}</span>
                            <v-text-field
                                    v-if="!readonlyFields"
                                    label="Внешний ключ для уровня"
                                    v-model="modalData.levelKey"
                                    :rules="rules.levelKey"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row >
                          <v-flex xs4>
                            <v-subheader>Наименование уровня</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="Наименование уровня"
                                    v-model="modalData.levelTitle"
                                    :rules="rules.required"
                                    required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>

              <!-- Удаление -->

              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить уровень?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
    import colors from 'vuetify/es5/util/colors';
    import Util from '@/util';

    export default {
        components: {
        },
        data () {
            return {
                modalData: {},
                oldModalData: {},
                editedIndex: {},
                valid: true,
                readonlyFields: true,
                openColorBox: false,
                colors,
                rules: {
                    required: [ v => !!v || 'Обязательное поле' ],
                    levelKey: [
                        v => !!v || 'Ключ не может быть пустым',
                        v => v.split(' ').length === 1 || 'Нельзя использовать пробелы',
                        v => this.levelData.filter(el => el.levelKey === v).length === 0 || 'Такой ключ уже существует',
                    ],
                },
                search: '',
                popupRemove: {
                    isOpen: false
                },
                popupEdit: {
                    isOpen: false,
                    isEditing: false,
                },
                complex: {
                    selected: [],
                    headers: [
                        {
                            text: 'ID уровня',
                            value: 'levelId'
                        },
                        {
                            text: 'Внешний ключ',
                            value: 'levelKey'
                        },
                        {
                            text: 'Наименование уровня',
                            value: 'levelTitle'
                        },
                        {
                            text: 'Действия',
                            value: ''
                        }
                    ],
                }
            };
        },

        mounted: function () {

            /**
             * Загружаем данные по уровням при первой отрисовке страницы, если levelData не пустой, то не обновляемся
             */
            if (this.levelData.length === 0)
            {
                this.refresh();
            }
        },

        computed: {

            /**
             * Данные по уровням
             * @returns {default.computed.levelData|(function())|Array|getters.levelData}
             */
            levelData () {
                return this.$store.getters['level/levelData']
            },

        },

        methods: {

            /**
             * Обновление данных по уровням
             */
            refresh () {
                this.$store._actions['level/getLevelData'][0]();
            },

            /**
             * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
             * @param item
             */
            editOpen (item) {
                // Если редактирование
                if (item !== null && typeof (item) !== 'undefined') {
                    this.modalData = item;
                    this.oldModalData = Object.assign({}, item);
                    this.editedIndex = this.levelData.indexOf(item);
                    this.readonlyFields = true;
                    // Если добавление
                } else {
                    this.modalData = {
                        levelId: -1,
                        levelKey: '',
                        levelTitle: '',
                    };
                    this.oldModalData = {};
                    this.editedIndex = -1;
                    this.readonlyFields = false;
                }
                this.popupEdit.isOpen = true;
            },

            /**
             * Отмена редактирования
             */
            editCancel () {
                if (this.editedIndex != -1) {
                    Object.assign(this.levelData[this.editedIndex], this.oldModalData);
                }
                this.popupEdit.isOpen = false;
            },

            /**
             * Сохранение отредактированного элемента
             */
            submit () {
                if (this.$refs.form.validate()) {
                    this.$store._actions['level/saveLevelData'][0]({index: this.editedIndex, data: this.modalData}).then(() => {
                        this.popupEdit.isOpen = false;
                    })
                }
            },

            /**
             * Открытие модального окна с подтверждением удаления
             * @param data
             */
            removeItemConfirm (data) {
                this.popupRemove.isOpen = true;
                this.modalData = data;
            },

            /**
             * Удаление элемента
             * @param item
             */
            actionRemove (item) {
                this.$store._actions['level/removeLevelData'][0]({item: item});
                this.popupRemove.isOpen = false;
            },

            /**
             * Изменение цвета по клику
             * @param color
             */
            changeLevelColor (color) {
                this.modalData.levelColor = color;
                this.openColorBox = false;
            },

            /**
             * Вывод последнего элемента
             * @param str
             * @returns {*}
             */
            endStr (str) {
                return str[str.length - 1];
            },

            /**
             * Конвертирование в строки в класс
             * @param str
             * @returns {*}
             */
            convertToClass (str) {
                const end = this.endStr(str);
                const sub = str.substr(0, str.length - 1);

                if (isNaN(parseInt(end, 10))) return str;

                return `${sub}-${end}`;
            },

            /**
             * Получение цвета по ключу
             * @param key
             * @returns {string}
             */
            getColorClass (key) {
                if (['white', 'transparent'].includes(key) ||
                    key.indexOf('light') > -1 ||
                    key.indexOf('accent') > -1
                ) return 'black--text';

                return 'white--text';
            }
        }
    };
</script>

<style>
  .v-chip__content{
    cursor: pointer!important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/ui/Levels.vue